import { axiosWithoutAuth } from "./axiosInstances";

// KHAN-255: email/sendmail/ -> mails/send/ (MailViewSet.send). El cliente
// sigue usando axiosWithoutAuth: solo cambia la ruta, no el comportamiento
// de autenticacion de esta llamada.
export async function sendMail(subjet, to, message){
    return axiosWithoutAuth().post('mails/send/',{
        message:message,
        subjet:subjet,
        to:to
    })
}